import {ParcelGeometry} from "./map/parcel-geometry";

export class SavedFlurstueck{

  constructor() {
  }

  id: number;
  number: string;
  geometry?: ParcelGeometry;

}
